import { render, staticRenderFns } from "./LessonHeader.vue?vue&type=template&id=7370275b&scoped=true"
import script from "./LessonHeader.vue?vue&type=script&lang=js"
export * from "./LessonHeader.vue?vue&type=script&lang=js"
import style0 from "./LessonHeader.vue?vue&type=style&index=0&id=7370275b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7370275b",
  null
  
)

export default component.exports